"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightOverviewFlightCard = void 0;
const classnames_1 = __importDefault(require("classnames"));
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const dateTimeFormat_1 = require("../../../utils/dateTimeFormat");
const roundMoney_1 = require("../../../utils/roundMoney");
const Icon_1 = require("../../Icon");
const utils_1 = require("./utils");
require("./index.scss");
const className = 'flight-overview-flight-card';
const FlightOverviewFlightCard = (props) => {
    var _a, _b, _c;
    const { className: propsClassName, flight, withDate, minDesktop } = props;
    const classNames = (0, classnames_1.default)(className, propsClassName !== null && propsClassName !== void 0 ? propsClassName : '', { [`${className}--min-on-desktop`]: minDesktop });
    const { locale } = (0, react_intl_1.useIntl)();
    const originName = (_b = (_a = flight.value.origin.name) === null || _a === void 0 ? void 0 : _a[locale]) !== null && _b !== void 0 ? _b : '';
    const dateFormat = withDate ? dateTimeFormat_1.DATETIME_FORMAT : dateTimeFormat_1.TIME_FORMAT;
    const departure = moment_1.default.parseZone(flight.value.departure).format(dateFormat);
    const destination = (_c = flight.value.destination.name) === null || _c === void 0 ? void 0 : _c[locale];
    const arrival = moment_1.default.parseZone(flight.value.arrival).format(dateFormat);
    const minPrice = (0, utils_1.getOneWayFlightMinPrice)(flight.value);
    const price = `${(0, roundMoney_1.localizeMoney)(minPrice, locale, 'FlightsOverview/FlightOverviewFlightCard')} CHF`;
    const number = flight.value.number;
    return (react_1.default.createElement("div", { className: classNames, onClick: flight.onClick },
        react_1.default.createElement("p", { className: `${className}__origin` }, originName),
        react_1.default.createElement("p", { className: `${className}__departure` }, departure),
        react_1.default.createElement("div", { className: `${className}__icon` },
            react_1.default.createElement(Icon_1.Icon, { name: 'airplane-horisontal' })),
        react_1.default.createElement("p", { className: `${className}__destination` }, destination),
        react_1.default.createElement("p", { className: `${className}__arrival` }, arrival),
        react_1.default.createElement("p", { className: `${className}__price` }, price),
        react_1.default.createElement("p", { className: `${className}__number` }, number)));
};
exports.FlightOverviewFlightCard = FlightOverviewFlightCard;
//# sourceMappingURL=index.js.map